<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="审核状态"
                prop="verifyStatus"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.verifyStatus"
                  placeholder="请选择状态"
                >
                  <el-option label="待审核" value="0"></el-option>
                  <el-option label="已拒绝" value="-1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <!-- <el-table-column prop="title" label="测试" align="center">
        </el-table-column> -->
        <el-table-column prop="userName" label="用户信息" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>
        <el-table-column prop="img" label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img[0]" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="verifyDes" label="描述" align="center">
        </el-table-column>
        <el-table-column
          prop="verifyStatus"
          label="审核状态"
          align="center"
          :formatter="statusList"
        >
        </el-table-column>
        <el-table-column prop="createTime" label="发布时间" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="see(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.verifyStatus == 0"
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog title="审核" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="审核状态" prop="verifyStatus">
                <el-select clearable filterable v-model="addData.verifyStatus" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="描述" prop="verifyDes">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入描述"
                  v-model="addData.verifyDes"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 查看 -->
      <el-dialog title="查看" :visible.sync="isAddModals" width="50%">
        <el-form
          ref="forms"
          :model="fromData"
          label-width="90px"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片" prop="img">
                <multigraph
                  :url.sync="fromData.img"
                  :src="fromData.img"
                  :many="3"
                ></multigraph>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户名称" >
                <el-input
                  placeholder="无"
                  v-model="fromData.userName"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" >
                <el-input
                  placeholder="无"
                  v-model="fromData.phone"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>            
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="审核描述" >
                <el-input
                  placeholder="无"
                  v-model="fromData.verifyDes"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>         
          </el-row>          
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动内容" prop="content">
                <ueditor v-model="fromData.content"></ueditor>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isAddModals = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor";
import multigraph from "../../components/multigraph";
export default {
  components: {
    upload,
    ueditor,
    multigraph,
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isAddModal: false,
      isShowloading: false,
      isAddModals: false,
      fromData: {},
      options: [
        {
          label: "通过",
          value: 1,
        },
        {
          label: "拒绝",
          value: -1,
        },
      ],
      addData: {
        id: "",
        verifyDes: "",
        verifyStatus: "",
      },
      addDataRules: {
        verifyStatus: [
          { required: true, message: "请选择审核状态", trigger: "blur" },
        ],
        verifyDes: [
          { required: true, message: "请输入审核描述", trigger: "blur" },
        ],
      },
      searchForm: {
        verifyStatus: "",
      },
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    see(row) {
      this.fromData = JSON.parse(JSON.stringify(row));
      this.isAddModals = true;
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    //
    statusList(row) {
      if (row.verifyStatus == 0) {
        return "待审核";
      } else if (row.verifyStatus == -1) {
        return "已拒绝";
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            verifyDes: this.addData.verifyDes,
            verifyStatus: this.addData.verifyStatus,
          };
          this.$Apis.neighboursVerify(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 审核
    updataCharacter(row) {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.id = row.id;
      this.isAddModal = true;
    },
    onLoad(ind) {
      if(ind == 1) {
        this.currentPage = 1
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        verifyStatus: this.searchForm.verifyStatus || "0,-1",
      };
      this.$Apis.neighboursList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.ind = ind + 1;
            item.img = item.img.split(",");
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
</style>